import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import { Modal } from "antd";

import { ApplicationsActions, selectCurrentApplicationId, selectIsRiskUpdateLoading } from "@redux";
import { ContentLoader, FormField, FormFieldType } from "@components";
import { i18, trb, required, numberFormat } from "@utilities";
import { allowOnlyNumbers } from "@utilities/helpers";

export const EditRiskModal = ({ risk, onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const isLoading = useSelector(selectIsRiskUpdateLoading);

  const handleRiskEditSubmit = async values => {
    try {
      delete values.riskDescription;
      await dispatch(
        ApplicationsActions.updateRiskHit(values, appId, i18.NotificationTitles.SuccessOperation)
      );
      onClose();
    } catch (e) {}
  };

  return (
    <Form
      onSubmit={handleRiskEditSubmit}
      initialValues={risk}
      mutators={{
        setScoreAfterBlur: (_args, state, utils) => {
          const lastScore = Number(state.lastFormState.values.riskScore);
          if (lastScore > 100) {
            utils.changeValue(state, "riskScore", () => 100);
          }
          if (lastScore < 0 || !lastScore) {
            utils.changeValue(state, "riskScore", () => 0);
          }
        }
      }}
      render={({ handleSubmit, form }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            <form className="my-4" onSubmit={handleSubmit}>
              {isLoading && <ContentLoader />}
              {!isLoading && (
                <>
                  <FormField
                    name="riskDescription"
                    component={FormFieldType.input}
                    title={trb(i18.ApplicationsLabels.RiskDescription)}
                    size="large"
                    disabled
                    className="mb-4"
                  />
                  <FormField
                    name="comment"
                    component={FormFieldType.input}
                    title={trb(i18.ApplicationsLabels.Comment)}
                    validate={required}
                    size="large"
                    className="mb-4"
                  />
                  <FormField
                    name="riskScore"
                    component={FormFieldType.number}
                    onKeyDown={allowOnlyNumbers}
                    title={trb(i18.ApplicationsLabels.RiskScore)}
                    size="large"
                    onBlur={form.mutators.setScoreAfterBlur}
                    formatNumber={numberFormat().number}
                    className="mb-4"
                  />
                </>
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
